import FabMaterial from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";

import styled from "styled-components";

const StyledFab = styled(FabMaterial)`
  position: fixed !important;

  // position: absolute !important;
  right: 2em;
  bottom: 6em;
`;

export const Fab = ({ onClick }) => {
  return (
    <StyledFab color="primary" aria-label="add" onClick={onClick}>
      <AddIcon />
    </StyledFab>
  );
};
